import { z } from 'zod';
import { AdminPageQuerySchema, adminPage } from './page';
import { ProStatusSchema } from '../pro';

/**
 * Nearmirer Pro moderation queue. **Web-only** — never imported by mobile.
 * Moderators see the request (handle, email, the reason the user typed,
 * timestamps) and approve / deny / revoke. They never see Pro message bodies.
 */

export const AdminProRequestSchema = z.object({
  userId: z.string(),
  handle: z.string().nullable(),
  email: z.string(),
  reason: z.string().nullable(),
  status: ProStatusSchema,
  requestedAt: z.iso.datetime(),
  reviewedByHandle: z.string().nullable(),
  reviewedAt: z.iso.datetime().nullable(),
  decisionNote: z.string().nullable(),
});
export type AdminProRequest = z.infer<typeof AdminProRequestSchema>;

export const AdminProQuerySchema = AdminPageQuerySchema.extend({
  filter: z.enum(['all', 'requested', 'active', 'denied', 'revoked']).default('requested'),
  q: z.string().max(120).optional(),
});
export type AdminProQuery = z.infer<typeof AdminProQuerySchema>;

export const AdminProResponseSchema = adminPage(AdminProRequestSchema);
export type AdminProResponse = z.infer<typeof AdminProResponseSchema>;

export const AdminProActionSchema = z.object({
  action: z.enum(['approve', 'deny', 'revoke']),
  reason: z.string().min(3).max(500),
});
export type AdminProAction = z.infer<typeof AdminProActionSchema>;
